import { Box, Divider, Stack, Typography, styled } from "@mui/material";
import LinkWithQuery from "../../../components/helpers/LinkWithQuery.js";

const StyledTypography = styled(Typography)({
  fontSize: 24,
  fontWeight: 600,
});
const HelpInfo = () => (
  <Stack gap={2}>
    <Divider />
    <Box>
      <StyledTypography>Contact Support:</StyledTypography> Feel free to contact
      our{" "}
      <Typography
        component={LinkWithQuery}
        to="/contact-us"
        target="_blank"
        rel="noopener noreferrer"
      >
        support team
      </Typography>{" "}
      for assistance.
    </Box>
  </Stack>
);

export default HelpInfo;
